module.exports = __webpack_public_path__ + "img/thuyenvien.7d86f32d.jpg";